// Customer content missing a customer language: a warning, never a refusal.
// Mirrors internal/i18n/missing.go; the text still falls back (resolveText).
import { languageInfo } from './customer'
import { isSame } from './same'

const PLACEHOLDER = /\{\{[^{}]*\}\}|\{[^{}]*\}/g

/** Whether a text says something a translator would change: a letter outside its placeholders. */
export function needsWords(s: string | undefined): boolean {
  return /\p{L}/u.test((s ?? '').replace(PLACEHOLDER, ''))
}

/**
 * The customer languages a text has no words in while another has some. With
 * `keys`, a blank kept under a language is meant (a cleared button title) and
 * only a language with no entry at all misses.
 */
export function missingLanguages(
  text: Record<string, string> | undefined | null,
  languages: readonly string[],
  keys = false,
): string[] {
  if (!text || isSame(text) || !Object.values(text).some(needsWords)) return []
  return languages.filter((c) => (keys ? !Object.prototype.hasOwnProperty.call(text, c) : !(text[c] ?? '').trim()))
}

/** Codes as English language names, in the order given: "Russian, Polish". */
export function languageNames(codes: readonly string[]): string {
  return codes.map((c) => languageInfo(c).name).join(', ')
}

/** Several texts' missing languages: each language once, in the offered order, and how many texts miss any. */
export function missingAcross(lists: readonly (readonly string[])[], languages: readonly string[]): { codes: string[]; n: number } {
  const seen = new Set(lists.flat())
  return { codes: languages.filter((c) => seen.has(c)), n: lists.filter((l) => l.length > 0).length }
}
